/** Where a subscription is cancelled, by where it was bought. */

export interface CancelGuide {
  key: string;
  href: string;
  label: string;
  detail: string;
}

const STORE_GUIDES: CancelGuide[] = [
  {
    key: 'apple',
    href: 'https://support.apple.com/en-us/HT202039',
    label: 'Cancel a subscription with Apple',
    detail: 'If you subscribed through the App Store',
  },
  {
    key: 'google',
    href: 'https://support.google.com/googleplay/answer/7018481',
    label: 'Cancel a subscription on Google Play',
    detail: 'If you subscribed through Google Play',
  },
];

/** Where each kind of subscription is cancelled: the brand's Stripe portal first, where it has one, then the app stores. */
export function cancelGuides(stripePortal: string | null): CancelGuide[] {
  const stripe: CancelGuide[] = stripePortal
    ? [{ key: 'stripe', href: stripePortal, label: 'Cancel a subscription paid by card', detail: 'If you subscribed on the web, through Stripe' }]
    : [];
  return [...stripe, ...STORE_GUIDES];
}
